<script setup>
import { ref, computed, inject} from 'vue'
import { useWorkspaceStore } from '@stores/WorkspaceData';
const wpStore = useWorkspaceStore()
import { planService } from '@requests/Main/plan.service';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
const toast = inject('toast')

const Plan = computed(() => wpStore.experiment.Plan)
const BSTdata = computed(() => Plan.value?.bst?.records || [])

// A — разворот на координаты цели (параметры: долгота/широта), B — на углы ориентации (тангаж/крен)
const modeLabel = {A: 'A — на координаты цели', B: 'B — на углы ориентации'}
const formatTime = (unix) => unix == null ? '' : new Date(unix * 1000).toLocaleString('ru-RU')

const creating = ref(false)
const CreateBST = async () => {
  creating.value = true
  const result = await planService.CreateBST(Plan.value)
  await planService.Reload()
  creating.value = false
  if(result){
    toast.success('Полётное задание сформировано')
  }
}
</script>

<template>
<Panel header="Полётное задание" id="FlightMission">
    <Button label="Сформировать полётное задание" raised @click="CreateBST" :icon="`pi ${creating?'pi-spin pi-spinner':'pi-refresh'}`" iconPos="right" :disabled="creating || !Plan"/>
    <DataTable :value="BSTdata" tableStyle="min-width: 50rem">
      <Column field="time" header="Время">
        <template #body="{data}">{{ formatTime(data.time) }}</template>
      </Column>
      <Column field="mode" header="Режим полёта">
        <template #body="{data}">{{ modeLabel[data.mode] || data.mode }}</template>
      </Column>
      <Column field="parameter1" header="Параметр 1"></Column>
      <Column field="parameter2" header="Параметр 2"></Column>
      <template #empty>Полётное задание не сформировано</template>
  </DataTable>
</Panel>
</template>

<style>

</style>
